import { useFarms } from 'app/agriculture/hooks/useFarms/useFarms';
import { FarmCard } from 'app/agriculture/routes/BackOffice/UserHome/components/FarmCard/FarmCard';
import { AddNewFarmCard } from 'app/agriculture/routes/BackOffice/UserHome/components/AddNewFarmCard/AddNewFarmCard';
import 'app/agriculture/routes/BackOffice/UserHome/components/FarmCards/FarmCards.scss';
import { Heading } from 'app/agriculture/components/Heading/Heading';

export function FarmCards() {
    const farms = useFarms();

    return (
        <div className="FarmCards">
            <Heading>Active farms</Heading>
            <div className="FarmCards__cards">
                {farms.map((farm) => (
                    <FarmCard className="FarmCards__card" key={farm.id} farm={farm} />
                ))}
                <AddNewFarmCard className="FarmCards__card" />
            </div>
        </div>
    );
}
